import styled from "styled-components"

import { LuPencilLine } from "react-icons/lu";
import ContainerInfo from "./ContainerInfo";
import { useModal } from "../../contexts/ModalContext";
import ModalEditLocacao from "./ModalEditLocacao";

const Container = styled.div`
    width: 100%;
    background-color: #EBEBEB;
    border-radius: 15px;
    box-sizing: border-box;
    overflow: hidden;
    margin-top: 10px;
`
const Cabecalho = styled.div`
    width: 100%;
    height: 50px;
    background-color: #dbdbdb;
    box-sizing: border-box;
    display: flex;
    padding: 0 15px;
    align-items: center;
    justify-content: space-between;
`

const Titulo = styled.h2`
    margin: 0;
    font-size: 14px;
    font-weight: bold;
`
const EditBtn = styled.div`
    width: 30px;
    height: 30px;
    border-radius: 50%;
    box-sizing: border-box;
    border: 1px solid #000;
    display: flex;
    & svg{
        width: 15px;
        height: 15px;
        color: #000;
        margin: auto;
    }
    cursor: pointer;
`
const Corpo = styled.div`
    width: 100%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 10px;
`

const FormularioLocacao = ({ data, fetchData }) => {

    const { openModal, isModalOpen } = useModal();

    const abrirModalAloc = () => {
        openModal('editModalLocado');
    }

    return (
        <>
            <Container>
                <Cabecalho>
                    <Titulo>INFORMAÇÕES DE LOCAÇÃO</Titulo>
                    <EditBtn onClick={abrirModalAloc} >
                        <LuPencilLine />
                    </EditBtn>
                </Cabecalho>
                <Corpo>
                    <ContainerInfo title="ALOJAMENTO" value={ data?.rep_temp || '-' } />
                    <ContainerInfo title="QUARTO" value={ data?.quarto_rep_temp || '-' } />
                </Corpo>
            </Container>
            {isModalOpen('editModalLocado') && (
                <ModalEditLocacao
                    info={ data }
                    fetchData={ fetchData }
                />
            )}
        </>
    )
}
export default FormularioLocacao
